import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { http } from '../helper';
import { BaseUrl } from '../common/config';
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
export const DepotTopSellingProducts = ({ }) => {

    const priceFormat = (price) => {
        return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2,
        });
    };


    var currentTime = new Date();
    var currentyear = currentTime.getFullYear();
    var currentMonth = currentTime.getUTCMonth() + 1;
    const [filter, setFilter] = useState(0);
    const [catFilter, setCatFilter] = useState(0);
    const [filtertext, setFilterText] = useState('');
    const [topSellingProducts, setTopSellingProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const getCurrentFiscalYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        // Fiscal year starts in September
        const startYear = month >= 9 ? year : year - 1;
        const endYear = startYear + 1;
        return `${startYear}-${endYear}`;
    };
    const [period, setPeriod] = useState(getCurrentFiscalYear());
    const [months, setMonths] = useState('9');
    const [quarter, setQuarter] = useState('');
    const [mainDepot, setMainDepot] = useState("");
    const [subDepotList, setSubDepotList] = useState([]);
    const [mainDepotList, setMainDepotList] = useState([]);
    const [depots, setDepots] = useState([]);
    const [subDepot, setSubDepot] = useState("");
    const MonthNames = ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"];
    const currentFiscalMonth = new Date().getMonth(); // 0-indexed: Jan = 0, Apr = 3, Sep = 8

    const quarterNames = {
        1: "Sep - Nov",
        2: "Dec - Feb",
        3: "Mar - May",
        4: "Jun - Aug"
    };

    const getCurrentFiscalQuarter = () => {
        const month = new Date().getMonth() + 1; // 1–12
        if (month >= 9 && month <= 11) return 1;   // Sep–Nov
        if (month === 12 || month <= 2) return 2;  // Dec–Feb
        if (month >= 3 && month <= 5) return 3;    // Mar–May
        return 4;                                  // Jun–Aug
    };

    const getAvailableQuarters = (selectedFiscalYear) => {
        const currentFiscalYear = getCurrentFiscalYear();
        const currentQuarter = getCurrentFiscalQuarter();

        return Object.entries(quarterNames)
            .filter(([quarterNumber]) => {
                if (selectedFiscalYear === currentFiscalYear) {
                    return Number(quarterNumber) <= currentQuarter;
                }
                return true; // show all for past years
            })
            .map(([quarterNumber, label]) => (
                <option key={quarterNumber} value={quarterNumber}>
                    {label}
                </option>
            ));
    };
    useEffect(() => {
        const now = new Date();
        const month = now.getMonth() + 1;
        const fiscalQuarterMap = {
            9: 1, 10: 1, 11: 1,
            12: 2, 1: 2, 2: 2,
            3: 3, 4: 3, 5: 3,
            6: 4, 7: 4, 8: 4
        };
        const currentFiscalQuarter = fiscalQuarterMap[month];
        setQuarter(currentFiscalQuarter);
    }, []);

    useEffect(() => {

        let URL = BaseUrl + `admin/getdepots`;
        http
            .get(URL)
            .then((response) => {
                let responseData = response.data.data;

                const uniqueDepots = Array.from(new Set(responseData.map(item => item.mainDepot)))
                    .map(mainDepot => responseData.find(item => item.mainDepot === mainDepot));
                setSubDepotList(responseData);
                setDepots(responseData);
                setMainDepotList(uniqueDepots);

            })
            .catch((err) => {
                console.log(err);
            });
    }, []);
    useEffect(() => {
        if (mainDepot === "") {
            setSubDepotList(depots);
        } else {
            setSubDepotList(depots.filter(item => item.mainDepot === mainDepot));
        }
    }, [mainDepot, mainDepotList]);

    useEffect(() => {
        if (filter === "custom" && (!fromDate || !toDate)) {
            // Don't make the API call if dates are missing for the "custom" filter
            return;
        }
        let URL1 = BaseUrl + "admin/depottopsellingproducts";
        let payload = {};
        if (filter === 'custom') {
            payload = {
                filter: filter, datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
                category: catFilter,
                dateto: format(new Date(toDate), "yyyy-MM-dd"),
                mainDepot: mainDepot,
                subDepot: subDepot,
            }
            setShowDatePicker(false);
        }
        else if (["weekly", "monthly", "quarterly", "FYdata"].includes(filter)) {
            payload = {
                filter: filter,
                category: catFilter,
                datefrom: "",
                dateto: "",
                period: period,
                mainDepot: mainDepot,
                subDepot: subDepot,
            };
        }
        else {
            payload = {
                filter: parseInt(filter), datefrom: '',
                dateto: '',
                category: catFilter,
                mainDepot: mainDepot,
                subDepot: subDepot,
            }
        }
        setIsLoading(true);
        http.post(URL1, payload).then((response) => {
            setIsLoading(false);
            const actualMonth = parseInt(months);
            let filteredData = [];

            if (filter === 'monthly') {
                filteredData = response.data.data
                    .filter(item => item.month === actualMonth)

            } else if (filter === 'quarterly') {
                filteredData = response.data.data
                    .filter(item => item.fiscalQuarter === quarter)

            }
            else {
                filteredData = response.data.data.filter((item) => item.sum > 0)

            }
            setTopSellingProducts(filteredData);
        }).catch((err) => {
            console.log(err);
        })


    }, [filter, fromDate, toDate, catFilter, months, quarter, period, mainDepot, subDepot]);

    // Calculate dynamic pagination options
    const calculatePaginationOptions = (totalRecords, interval) => {
        const options = [];
        for (let i = interval; i <= totalRecords; i += interval) {
            options.push(i);
        }
        return options;
    };


    const DateChange = (value, type) => {
        if (type === "from") {
            setFromDate(value);

            if (toDate && value && value > toDate) {
                setToDate(null);
            }
        } else if (type === "to") {
            if (!fromDate || value >= fromDate) {
                setToDate(value);
            } else {
                // Handle invalid date selection
                //alert("The 'To' date cannot be earlier than the 'From' date.");
                setToDate(null);
            }
        }
    };

    const totalRecords = topSellingProducts.length; // Get the total records count
    const paginationOptions = calculatePaginationOptions(totalRecords, 10); // Generate options with interval of 10

    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, "0");
        const day = String(dateObject.getDate()).padStart(2, "0");
        return `${day}/${month}/${year}`;
    }
    const changeMainDepotHandler = (e) => {
        setSubDepot("");
        setMainDepot(e.target.value);
    }
    const changeSubDepotHandler = (e) => {
        setSubDepot(e.target.value);
    }

    const changeCatFilterHandler = (e) => {
        setCatFilter(e.target.value);
        setShowDatePicker(false);
    }
const changePeriodHandler = (e) => {
  const newPeriod = e.target.value;
  setPeriod(newPeriod); // update selected fiscal year in state
  //split fiscal year
  const [newStartYear, newEndYear] = newPeriod.split('-').map(Number);
  
  const fiscalStartMonthIndex = 8; // 0-based index for September

  const today = new Date();
  const currentFiscalYear = getCurrentFiscalYear();
  //compare sleted year with currentfiscalyear 
  const isCurrentFiscalYear = newPeriod === currentFiscalYear;

  // MONTHLY filter logic
  if (filter === 'monthly') {
    let visibleMonthNames = MonthNames;

    if (isCurrentFiscalYear) {
      // Calculate current fiscal month index 
      const currentMonthIndex = today.getMonth(); // 0-based
      const monthsPassedSinceFiscalStart =
        (currentMonthIndex - fiscalStartMonthIndex + 12) % 12;
      const maxVisibleIndex = monthsPassedSinceFiscalStart;

      visibleMonthNames = MonthNames.slice(0, maxVisibleIndex + 1);
    }

    const selectedMonthIndex = MonthNames.indexOf(months);
    const isValidMonth =
      selectedMonthIndex >= 0 && selectedMonthIndex < visibleMonthNames.length;

    if (!isValidMonth) {
      const defaultMonthNumber = ((0 + fiscalStartMonthIndex) % 12) + 1;
      setMonths(String(defaultMonthNumber));
    }
  }

  // QUARTERLY filter logic
  if (filter === 'quaterly') {
    const currentQuarter = getCurrentFiscalQuarter();
    let maxQuarter = 4;

    if (isCurrentFiscalYear) {
      maxQuarter = currentQuarter;
    }

if (parseInt(quarter) > maxQuarter) {
  setQuarter(maxQuarter > 0 ? String(maxQuarter) : "1");
}

  }
};
    const changeMonthHandler = (e) => {
        setMonths(e.target.value);
    };
    const changeFilterHandler = (e) => {
        setFilter(e.target.value);
        setFilterText(e.target.options[e.target.selectedIndex].text);
        if (e.target.value === 'custom') {
            setShowDatePicker(true);

        } else {
            setShowDatePicker(false);
            setFromDate(null);
            setToDate(null);
            setFilter(e.target.value);

        }
    };
    const options = [];

    for (let i = currentyear; i >= 2023; i--) {
        if (i === currentyear && currentMonth < 9) {
            continue;
        }
        const year = i;
        options.push(
            <option value={year + "-" + (year + 1)}>{year + "-" + (year + 1)}</option>
        );
    }

    const currentFiscalYear = getCurrentFiscalYear();
    let visibleMonthNames = MonthNames;
    if (period === currentFiscalYear) {
    // Limit to current fiscal month
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12; // Sep=0, Oct=1, ... Aug=11
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
    }
    
    function fixDescription(description) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = description;
    let decoded = textarea.value;
    decoded = decoded.replace(/&apos;/g, "'")
                     .replace(/apos;/g, "'")
                     .replace(/&quot;/g, '"')
                     .replace(/quot;/g, '"')
                     .replace(/&amp;/g, '&')
                     .replace(/amp;/g, '&');

    return decoded;
    }
    let loadingbuffer = isLoading ? 'loading-buffer' : '';
    const columns = [
        {
            name: "Product Code",
            selector: row => {
                if (row.ProductNumber && typeof row.ProductNumber === "string") {
                    return row.ProductNumber.includes("_")
                        ? row.ProductNumber.substring(0, row.ProductNumber.indexOf("_"))
                        : row.ProductNumber;
                }
                return ""; // Return a default value if ProductNumber is undefined or not a string
            },
            sortable: false,
        },
        {
            name: "Product Name",
            selector: row => (
                <>
                    {fixDescription(row.Description)}
                    <a
                        className={row.UnitPrice === 0 && row.QuantityOrdered > 0 ? "free title-tooltip title-top" : "title-tooltip title-top"}
                        data-title={row.categoryId === "1"
                            ? "PIZZA"
                            : row.categoryId === "10" || row.categoryId === "13"
                                ? "PASTA, RICE & NOODLE SAUCES"
                            : row.categoryId === "14" 
                            ? "DESSERTS"
                                : "BURRITO"}>
                        <i className="fa fa-th-list" aria-hidden="true"></i>
                    </a>
                </>
            ),
            sortable: false,
        },

        {
            name: "Quantity Sold",
            selector: row => row.sum,
            sortable: false,
        },
        {
            name: "Total Revenue",
            selector: row => priceFormat(row.revenue),
            sortable: false,
        },
        {
            name: "Main / Local Depot",
            selector: row => (row.mainDepot + " / " + row.subDepot),
            sortable: false,
        },

    ];

    const customStyles = {
        rows: {
            style: {
                minHeight: '25px',
            },
        },
        headCells: {
            style: {
                padding: '8px', // override the cell padding for head cells

            },
        },
        cells: {
            style: {
                padding: '8px', // override the cell padding for data cells

            },
        },
    };

    const paginationComponentOptions = {
        rowsPerPageText: "",
        rangeSeparatorText: "",
        selectAllRowsItem: true,
        selectAllRowsItemText: "",
        noRowsPerPage: "",
    };
    return (
        <div className={`chart-container chart-top-selling ${loadingbuffer}`}>
            <div className="chart-Hdr">

                <h2 style={{ textAlign: "left" }}>Depot-Based Top Selling Products</h2>
                <div className="chart-fltr-Hldr">
                    <div className="chart-fltr">
                        {<select name="mainDepot" onChange={(e) => changeMainDepotHandler(e)}>
                            <option value="">Select Main Depot</option>
                            {mainDepotList.map(item => (
                                <option key={item.mainDepot} value={item.mainDepot}>{item.mainDepot}</option>
                            ))}
                        </select>}
                    </div>
                    <div className="chart-fltr">
                        {<select name="subDepot" onChange={(e) => changeSubDepotHandler(e)}>
                            <option value="">Select Local Depot</option>
                            {subDepotList.map(item => (
                                <option key={item.subDepot} value={item.subDepot}>{item.subDepot}</option>
                            ))}
                        </select>}
                    </div>
                    <div className="chart-fltr">
                        {<select
                            value={catFilter}
                            onChange={(e) => changeCatFilterHandler(e)}
                        ><option value={"all"}>All</option>
                            <option value={"pizza"}>PIZZA</option>
                            <option value={"pasta-rice-noodle-sauces"}>PASTA, RICE & NOODLE SAUCES</option>
                            <option value={"burrito"}>BURRITO</option>
                            <option value={"desserts"}>DESSERTS</option>
                        </select>}
                    </div>
                    <div className="chart-fltr" onMouseEnter={() => {
                        if (filter === "custom" && !showDatePicker) {
                            setShowDatePicker(true);
                        }
                    }}
                        onMouseLeave={() => {
                            if (filter === "custom" && showDatePicker) {
                                setShowDatePicker(false);

                            }
                        }}>
                        {<select
                            value={filter}
                            onChange={(e) => changeFilterHandler(e)}
                        ><option value={0}>All</option>
                            <option value={1}>Past 1 Day</option>
                            <option value={"weekly"}>Current Week</option>
                            <option value={"monthly"}>Monthly</option>
                            <option value={"quarterly"}>Quarterly</option>
                            <option value={"FYdata"}>FY Data</option>
                            <option value={30}>Past 30 Days</option>
                            <option value={90}>Past 90 Days</option>
                            <option value={180}>Past 180 Days</option>
                            <option value={365}>Past 1 Year</option>
                            <option value={'custom'}>Custom Date</option>
                        </select>}
                        {showDatePicker && (
                            <div className="date-picker-container">
                                <label>From:</label>
                                <DatePicker
                                    selected={fromDate}
                                    onChange={(date) => DateChange(date, "from")}
                                    showDisabledMonthNavigation
                                    dateFormat="dd/MM/yyyy"
                                    disablePast={true}
                                    maxDate={new Date()}
                                    placeholderText="Select Date"
                                />
                                <label>To:</label>
                                <DatePicker
                                    selected={toDate}
                                    showDisabledMonthNavigation
                                    dateFormat="dd/MM/yyyy"
                                    onChange={(date) => DateChange(date, "to")}
                                    disablePast={true}
                                    maxDate={new Date()}
                                    placeholderText="Select Date"
                                />
                            </div>
                        )}
                        {filter === 'quarterly' && (
                            <select
                                style={{ width: "160px" }}
                                value={quarter}
                                onChange={(e) => setQuarter(Number(e.target.value))}
                            >
                                {/* {Object.entries(quarterNames).map(([q, label]) => (
                                <option key={q} value={q}>{label}</option>
                                ))} */}
                                {getAvailableQuarters(period)}
                            </select>
                        )}

                        {filter === 'monthly' && <select style={{ width: "50px" }} value={months} onChange={(e) => changeMonthHandler(e)}>
                            {visibleMonthNames.map((monthName, index) => {
                                const monthNumber = ((index + 8) % 12) + 1; // fiscal-to-calendar month number
                                return (
                                    <option key={monthNumber} value={monthNumber}>
                                        {monthName}
                                    </option>
                                );
                            })}
                        </select>

                        }
                        {(filter === 'monthly' || filter === 'quarterly' || filter === 'FYdata') && <select
                            style={{ width: "170px" }}
                            value={period}
                            onChange={(e) => changePeriodHandler(e)}
                        >
                            {options}
                        </select>}
                    </div>
                </div>

                {/* <div className="chart-fltr">
                <select value={metric} onChange={(e) => setMetric(e.target.value)}>
                    <option value="qty">Total Qty Sold</option>
                    <option value="revenue">Total Sales Revenue</option>
                </select>
                </div> */}


                <div className="fltr-sub-val">
                    {topSellingProducts.length > 0 && (<span className='fltr-val'>
                        {"Total Qty Sold"}: <strong>
                            {
                                topSellingProducts.reduce((acc, item) => item.sum > 0 ? acc + item.sum : acc, 0)

                            }
                        </strong>
                        {" / "}
                        {"Total Revenue (Excl. of VAT)"}: <strong>
                            {
                                priceFormat(topSellingProducts.reduce((acc, item) => item.revenue > 0 ? acc + item.revenue : acc, 0))
                            }
                        </strong>
                        {(["Current Week", "Monthly", "Quarterly", 'FY Data'].includes(filtertext)) ? '' : filtertext != "" && filtertext != "Custom Date"
                            ? ' (' + filtertext + ')'
                            : filtertext === "Custom Date" && fromDate && toDate
                                ? ' (' + formatDate(fromDate) + " - " + formatDate(toDate) + ')'
                                : ' (' + "All" + ')'}</span>)}
                </div>
            </div>
            <DataTable
                columns={columns}
                data={topSellingProducts}
                customStyles={customStyles}
                noDataComponent={<div className='no-records-found'>Sorry, no data found for your filtered search.</div>}
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
                //paginationRowsPerPageOptions={paginationOptions} // Dynamic intervals
                paginationComponentOptions={paginationComponentOptions}
            // paginationComponentOptions={{
            //     rowsPerPageText: '', // Hides "Rows per page"
            // }}

            />
        </div>
    );
};